import {
  Button,
  Column,
  Columns,
  Content,
} from '@codeparva/ui-components-library';
import { Link } from 'gatsby';
import React from 'react';
import { Icon } from '../../../../../utilities/icomoon-css';
import { weakKey } from '../../../../../utilities/weakKey';
import { FacilityHrs } from '../../locationMap/components/FacilityHrs';
import { getFormattedHrs } from '../../locationMap/LocationMap';
import { FooterQuickLinks } from '../FooterQuickLinks';
import { FooterTermsPrivacySiteMapAndDisclaimer } from '../FooterTermsAndPrivacyPolicy';
import { FooterTypes } from '../footerTypes';
import {
  CopyRightComponent,
  PoweredByLogoComponent,
} from '../helpers/CopyRightAndPoweredByHelper';
import { NewFooterReachUs } from '../helpers/NewFooterReachUs';
import { useThemeContext } from '../hooks/themeContext';
import { useVariant } from '../hooks/VariantContext';

export const NewFooterVariantOne = ({
  quickLinksandReachUsData,
  facilityGateHours,
  socialMediaIconsData,
  labelsLogoandCityStateNames,
  labelsAndLogos,
  termsPrivacySiteMapAndDisclaimer,
}: FooterTypes.TFooterVariant) => {
  const { navLinks, contactDetails } = quickLinksandReachUsData;

  const getMyFormattedHrs = (facilityGateHours: any) => {
    return getFormattedHrs(facilityGateHours.curlocations[0]);
  };
  const currTheme = useThemeContext();

  const getSocialMediaIcons = () => {
    const socialMedia = socialMediaIconsData?.socialIcons;
    if (socialMedia) {
      return socialMedia.map(platform => {
        const { iconsUrl, socialIcon } = platform;
        if (socialIcon) {
          return (
            <a
              href={iconsUrl}
              key={weakKey(platform)}
              target="_blank"
              className="is-flex is-align-items-center"
            >
              <Icon
                name={socialIcon}
                size={32}
                title={socialIcon}
                color="white"
              />
            </a>
          );
        }
        return <></>;
      });
    }
    return <></>;
  };

  const getFooterCTAButtons = () => {
    if (labelsLogoandCityStateNames) {
      enum ctaButtonColor {
        'cp-outline-button-highlighted',
        'cp-primary-button-highlighted',
      }
      const { buttonsConfig } = labelsLogoandCityStateNames;
      return (
        <>
          <div className="CTAButtons">
            {buttonsConfig &&
              buttonsConfig.map((button, index) => (
                <Button
                  className={`button ${ctaButtonColor[index]}`}
                  key={weakKey({ button })}
                >
                  <Link
                    to={button.url}
                    className="has-text-white"
                    state={{
                      from: button.label.toLowerCase().replace(/\s/g, ''),
                    }}
                  >
                    {button.label}
                  </Link>
                </Button>
              ))}
          </div>
        </>
      );
    }
    return <></>;
  };
  const currentVariant = useVariant();
  const { facilityLogo } = labelsAndLogos;
  return (
    <Content className="footerContainer">
      <Columns className="mainRow mb-6">
        {facilityLogo && (
          <Columns className="is-hidden-tablet mobile-row">
            <Column>
              <div>
                <img src={facilityLogo} width={150} />
                <hr />
                <div className="socialMediaIconsRow">
                  {getSocialMediaIcons()}
                </div>
              </div>
            </Column>
          </Columns>
        )}
        <Column className="firstColumn" size={2}>
          <Columns className="is-mobile">
            <Column className="quickLinksColumn">
              <h5>Quick Links</h5>
              <FooterQuickLinks navLinks={navLinks} />
            </Column>
            <Column className="ctaButtonsColumn is-hidden-tablet">
              {getFooterCTAButtons()}
            </Column>
          </Columns>
        </Column>
        {facilityGateHours && (
          <Column className="facilityTimings is-hidden-mobile" size={4}>
            <h5>Facility Timings</h5>
            <div className={`has-text-white`} key={weakKey(location)}>
              <FacilityHrs
                className="facilityHrsContainer"
                show={true}
                onFacilityHrsToggle={() => {}}
                formattedHrs={getMyFormattedHrs(facilityGateHours)}
                theme={currTheme}
              />
            </div>
          </Column>
        )}
        <Column className="reachUsColumn" size={4}>
          <h5>Reach Us</h5>
          {contactDetails && (
            <NewFooterReachUs
              address={contactDetails.facilityDetails.facilityAddress}
              emailAddress={contactDetails.emailID}
              phone={contactDetails.phoneNumber}
              googleMapUrl={contactDetails.facilityDetails.googleMapsUrl}
              className="newFooterReachUs"
            />
          )}
        </Column>
        <Column className="followUsSection  is-hidden-mobile">
          {socialMediaIconsData?.socialIcons && <h5>Follow Us</h5>}
          <Columns>
            <Column className="socialMediaIconsRow">
              {getSocialMediaIcons()}
            </Column>
          </Columns>
          <Column className="ctaButtonsColumn is-hidden-mobile">
            {getFooterCTAButtons()}
          </Column>
        </Column>
      </Columns>
      <Columns className="bottomRow pb-4">
        <hr className="is-hidden-tablet" />
        <CopyRightComponent
          labelsAndLogos={labelsAndLogos}
          contactDetails={contactDetails}
          currentVariant={currentVariant}
        />
        <PoweredByLogoComponent currentVariant={currentVariant} />
        <FooterTermsPrivacySiteMapAndDisclaimer
          termsPrivacySiteMapAndDisclaimer={termsPrivacySiteMapAndDisclaimer}
        />
      </Columns>
    </Content>
  );
};
